import React from "react";
import { ButtonGroup } from "react-bootstrap";
import { PaymentOrder } from "../../../business";
import { PaymentOrdersFactoryStrategyButton } from "../interfaces";
import { StrategyButtonBankSlipCancel, StrategyButtonBankSlipCreate, StrategyButtonBankSlipPayment, StrategyButtonBankSlipSend } from "../screens/components";

export class PaymentOrdersFactoryStrategyButtonImpl implements PaymentOrdersFactoryStrategyButton {
    createButton(paymentOrdersData: PaymentOrder): React.ReactElement<any, string | React.JSXElementConstructor<any>> {
        const { bi_status, payment_order_id } = paymentOrdersData;

        if (bi_status === null || bi_status === 4 || bi_status === 5) {
            return <StrategyButtonBankSlipCreate id={payment_order_id} />;
        }

        if (bi_status < 3) {
            return (
                <ButtonGroup aria-label="Basic example">
                    <StrategyButtonBankSlipSend id={payment_order_id} status={bi_status} />
                    <StrategyButtonBankSlipCancel id={payment_order_id} />
                    {bi_status === 2
                        ? <StrategyButtonBankSlipPayment id={payment_order_id} />
                        : <></>
                    }
                </ButtonGroup>
            );
        }

        return <></>;
    }
}